import {
  isSchemaDatapoint,
  isSchemaDatapointButton,
  isSchemaSimpleMultiValue,
  isSchemaTableMultiValue,
  isSchemaTuple,
  SchemaItem,
  SchemaSection,
} from '@rossum/api-client/schemas';
import { SchemaFieldIconType } from '@rossum/components/schema-field-icon/SchemaFieldIcon';
import { getUITypeFromSchema } from '../../../../redux/modules/schema/helpers';

type SchemaItemAndSection = SchemaSection | SchemaItem;

// TODO: reuse logic from form transformers by big boy Bro'
export const resolveIconType = (
  schemaObject: SchemaItemAndSection
): SchemaFieldIconType | null => {
  if (isSchemaSimpleMultiValue(schemaObject)) {
    return 'multiValue';
  }

  if (isSchemaTableMultiValue(schemaObject)) {
    return 'lineItem';
  }

  // @ts-expect-error redux vs api-client type mismatch
  const uiConfigurationType = getUITypeFromSchema(schemaObject);

  if (uiConfigurationType) {
    return uiConfigurationType;
  }

  if (schemaObject.category === 'section' || isSchemaTuple(schemaObject)) {
    return null;
  }

  if (isSchemaDatapointButton(schemaObject)) {
    return 'button';
  }

  if (isSchemaDatapoint(schemaObject)) {
    return 'captured';
  }

  return null;
};
